import { useMutation, useQuery } from "@tanstack/react-query";
import { roleApiService } from "modules/Library/Role/api/role.api";
import { userApiService } from "modules/Library/Users/api/userAssignment.api";
import {
  UpdateUserAssignmentPayload,
  UserAssignmentHookParams,
} from "modules/Library/Users/helpers/user.types";

interface ApiResponse<T = any> {
  data: T;
  message: string;
  statuscode: number;
}

// ------------------------------------------------------------------
//-- USER
// ------------------------------------------------------------------

export const useUserAssignmentService = ({
  searchText = null,
  pageNumber = 1,
  pageSize = 10,
}: UserAssignmentHookParams) => {
  const SelectAllQuery = useQuery({
    queryKey: ["userassignment-selectAll", searchText, pageNumber, pageSize],
    queryFn: () =>
      userApiService.getSelectAllData(searchText, pageNumber, pageSize),
  });

  const UpdateMutation = useMutation<
    ApiResponse,
    Error,
    any
  >({
    mutationFn: (payload: any) =>
      userApiService.updateData(payload),
  });

  const InsertMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload: any) => userApiService.insertData(payload),
  });

  const InsertUserMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload: any) => userApiService.insertUser(payload),
  });


  const DeleteMutation = useMutation<
    ApiResponse,
    Error,
    { userid: number | null; updatereason: string }
  >({
    mutationFn: (payload) =>
      userApiService.deleteData({
        userid: payload.userid,
        updatereason: payload.updatereason,
      }),
  });

  // Role DROPDOWN METHOD
  const RoleDropdownQuery = useQuery({
    queryKey: ["role-selectAll"],
    queryFn: () => roleApiService.getSelectAllData(),
  });

  const UserDropdownQuery = useQuery({
    queryKey: ["user-dropdown-selectAll"],
    queryFn: () => userApiService.getUserDropdownData(),
  });

  return {
    SelectAllQuery,
    UpdateMutation,
    InsertMutation,
    InsertUserMutation,
    DeleteMutation,
    RoleDropdownQuery,
    UserDropdownQuery,
  };
};
